import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '影视解说', href: '#media' },
  { label: '影迷热评', href: '#comments' },
  { label: '常见问题', href: '#faq' },
  { label: '手机观影', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNav('#hero');
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-fill text-white text-lg md:text-xl"></i>
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-900 whitespace-nowrap">
              被窝影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(item.href);
                }}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(item.href);
                }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}